// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "vendor.howler" + "." + "a8011ae7" + ".chunk.js";
};